export default __webpack_public_path__ + "img/clipboard-check.80591281.svg";